export default "__VITE_ASSET__Bh81k3Gi__"